/** @graphql cc **/

import gql from 'graphql-tag';

export const StarredSpacesQuery = gql`
	query StarredSpacesQuery {
		spaces(favourite: true, first: 99, status: "current") {
			nodes {
				alias
				id
				name
				key
				icon {
					path
				}
			}
		}
	}
`;

export const MyVisitedSpacesQuery = gql`
	query MyVisitedSpacesQuery {
		myVisitedSpaces(limit: 26) {
			nodes {
				spaces {
					alias
					id
					name
					key
					icon {
						path
					}
				}
			}
		}
	}
`;

export const MyVisitedSpacesWithCurrentSpaceQuery = gql`
	query MyVisitedSpacesWithCurrentSpaceQuery($selectedSpaceKey: String) {
		space(key: $selectedSpaceKey) {
			alias
			id
			name
			key
			icon {
				path
			}
			currentUser {
				isFavourited
			}
		}
		myVisitedSpaces(limit: 26) {
			nodes {
				spaces {
					alias
					id
					name
					key
					icon {
						path
					}
				}
			}
		}
	}
`;

export const AnonymousSpacesQuery = gql`
	query AnonymousSpacesQuery {
		spaces(first: 10) {
			nodes {
				alias
				id
				name
				key
				icon {
					path
				}
			}
		}
	}
`;

export const SearchSpacesQuery = gql`
	query SearchSpacesQuery($spaceNamePattern: String!, $isLicensed: Boolean!) {
		spaces(first: 30, status: "current", spaceNamePattern: $spaceNamePattern) {
			nodes {
				alias
				id
				name
				key
				icon {
					path
				}
				currentUser @include(if: $isLicensed) {
					isFavourited
				}
			}
		}
	}
`;
